<template>
  <div class="content-wrap">
    <p>
      <b>ค้นหารายงาน</b>
    </p>
    <div class="filter">
      <div class="filter-action">
        <div class="field">
          <el-input
            readonly
            :disabled="
              disabled
            "
            :value="
              project
            "
            @click.native="
              () => modal.project = true
            ">
            <template slot="prepend">
              โครงการ
            </template>
            <i
              v-if="
                form.projectId && !disabled
              "
              slot="suffix"
              class="
                el-icon-circle-close clear
              "
              @click.stop="
                clearProject
              "
            />
          </el-input>
        </div>
        <el-button
          type="sc-asset-light"
          :disabled="
            disabled
          "
          @click="
            () => panel = true
          ">
          ตัวกรอง
        </el-button>
      </div>
      <el-button
        type="sc-asset"
        icon="
          el-icon-search
        "
        :disabled="
          disabled
        "
        @click="
          () => $emit('search', form)
        ">
        ค้นหา
      </el-button>
    </div>
    <FilterProject
      :open.sync="
        modal.project
      "
      :selected="
        form.projectId
      "
      @select="
        selectProject
      "
      @error="
        (error, message) => $emit('error', error, message)
      "
    />
    <FilterPanel
      :open.sync="
        panel
      "
      :selected="
        form
      "
      :disabled="
        disabled
      "
      @select="
        applyFilter
      "
    />
  </div>
</template>

<script lang="js">

// Components
import FilterPanel from '@/features/subscribers-report/components/SubsReportFilterPanel'
import FilterProject from '@/features/subscribers-report/components/SubsReportFilterProject'

// Client
import { SubscriberReportClient as Client } from '@/clients/BackendAdminClient/subscriber-report'

// Common
import { SubsReportFilterCommon as FilterCommon } from '@/features/subscribers-report/common/subs-report-filter.common'

// Filter common
const { filter } = FilterCommon

export default {
  components: {
    FilterProject,
    FilterPanel,
  },
  props: {
    filter: {
      type    : Object,
      default : () => filter()
    },
    openPanel: {
      type   : Boolean,
      default: false
    },
    disabled: {
      type   : Boolean,
      default: false
    }
  },
  data () {
    return {
      form: filter(),
      projectName: null,
      modal: {
        project: false,
      },
    }
  },
  computed: {
    project() {

      // Validate project ID
      if (this.form.projectId) {
        return this.projectName || this.form.projectId
      }

      return 'ทั้งหมด'
    },
    panel: {
      get() {
        return this.openPanel
      },
      set(value) {
        this.$emit(
          'update:open-panel', value
        )
      }
    },
  },
  watch: {
    filter(value) {
      this.form = Object.assign(
        filter(), value
      )
      this.projectName = null
      this.mapProjectName()
    },
    'form.projectId': function() {
      this.$emit(
        'search', this.form
      )
    }
  },
  created() {

    // Init filter form
    this.form = Object.assign(
      filter(), this.filter
    )

    // Init project name
    this.mapProjectName()
  },
  methods: {
    applyFilter(item) {

      // Exclude Project
      const {
        projectId, ...restFilter
      } = item

      // Merge Filter
      Object.assign(
        this.form, restFilter
      )

      // Emit Search
      this.$emit(
        'search', this.form
      )
    },
    clearProject() {
      
      // Set project filter
      this.form.projectId = null
      
      // Set project name
      this.projectName = null
    },
    selectProject({ id, name }) {

      // Set project filter
      this.form.projectId = id

      // Set project name
      this.projectName = name
    },
    async mapProjectName() {

      // Form props
      const { projectId } = this.form

      // Validate project ID
      if (!projectId || this.projectName) return

      // Project List
      const projects = await Client.projects()

      // Matched Project
      const project = projects.find(
        (item) => Number(item.projectId) === projectId
      )

      // Set project name
      if (project) {
        this.projectName = project.projectName
      }
    },
  },
}

</script>

<style lang="css" scoped>

.content-wrap {
  display         : grid;
  gap             : var(--size-xs);
  background-color: white;
}

.filter, .filter-action {
  display: flex;
  gap    : var(--size-xs);
}

.filter-action {
  flex: 1;
}

.field {
  position: relative;
  flex    : 1;
}

.field >>> .el-input__inner {
  text-align: center;
  cursor    : pointer;
}

.field >>> .el-input__suffix{
  display    : flex;
  align-items: center;
}

.field >>>  .el-input__suffix-inner {
  display: flex;
}

.field .clear {
  font-size: 1.5rem;
  color    : #c0c4cc;
  cursor   : pointer;
}

@media only screen and (max-width: 768px) {
  .filter {
    flex-direction: column;
  }
}

</style>